import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-geren",
  "use": "icon-icon-geren-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon-geren\"><path d=\"M386.048 502.443a227.556 227.556 0 1 1 251.876 0c174.222 53.731 300.743 215.978 300.743 407.78a28.444 28.444 0 0 1-28.445 28.444H113.778a28.444 28.444 0 0 1-28.445-28.445c0-191.8 126.578-354.048 300.715-407.78z\" fill=\"#2C2C2C\" p-id=\"24527\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol